import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import PropTypes from 'prop-types';

const MetricCard = ({ title, value, unit, color }) => (
	<Card className='shadow-sm mb-3 card-border'>
		<Card.Body className='text-center py-3'>
			<Card.Text className='text-muted mb-1' style={{ fontSize: '0.85rem' }}>{title}</Card.Text>
			<h3 style={{ color: color || '#333', marginBottom: 0 }}>
				{typeof value === 'number' ? value.toLocaleString('es-MX', { maximumFractionDigits: 2 }) : value || '—'}
			</h3>
			{unit && <small className='text-muted'>{unit}</small>}
		</Card.Body>
	</Card>
);

const StatsPercentilesCards = ({ data }) => {
	if (!data || data.length === 0) {
		return <p className='text-center text-muted mt-3'>No percentile data available</p>;
	}

	const stats = data[0] || {};

	return (
		<>
			<Row className='mt-3'>
				<Col xs={6} md={4}>
					<MetricCard title='p50 (Median)' value={stats.p50_ms} unit='ms' color='#198754' />
				</Col>
				<Col xs={6} md={4}>
					<MetricCard title='p95' value={stats.p95_ms} unit='ms' color='#fd7e14' />
				</Col>
				<Col xs={6} md={4}>
					<MetricCard title='p99' value={stats.p99_ms} unit='ms' color='#dc3545' />
				</Col>
			</Row>
			<Row>
				<Col xs={6} md={3}>
					<MetricCard title='Average' value={stats.avg_ms} unit='ms' color='#0d6efd' />
				</Col>
				<Col xs={6} md={3}>
					<MetricCard title='Min' value={stats.min_ms} unit='ms' color='#6c757d' />
				</Col>
				<Col xs={6} md={3}>
					<MetricCard title='Max' value={stats.max_ms} unit='ms' color='#6c757d' />
				</Col>
				<Col xs={6} md={3}>
					<MetricCard title='Sample Count' value={stats.count} color='#6c757d' />
				</Col>
			</Row>
		</>
	);
}

StatsPercentilesCards.propTypes = {
	data: PropTypes.array
}

export default StatsPercentilesCards;
